import React from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
const Body=()=> <div className="flex min-h-[calc(100vh-72px)] bg-[#0f0f0f]"><Sidebar/><main className="min-w-0 flex-1"><Outlet/></main></div>;
export default Body;
